module.exports = __webpack_public_path__ + "static/media/6669.eb6e6b22.JPG";